import script from "./AboutMe.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutMe.vue?vue&type=script&setup=true&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=7d47966a&scoped=true&lang=css"

import exportComponent from "G:\\VUE\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d47966a"]])

export default __exports__